module.exports = __webpack_public_path__ + "img/gxjsqy.53605c2a.png";